import { JourneyInterface, QuestInterface } from "@swivl-mono/types";
import { SelectableOption } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";

import { QuestsModel, WorkflowsJourney } from "../Models/Quests/Quests.Model";

export function useQuestOptions(
  prependOptions?: SelectableOption[],
  filterJourney?: (journey: JourneyInterface) => boolean,
  filterQuest?: (quest: QuestInterface) => boolean,
): SelectableOption[] | undefined {
  const { workflows } = QuestsModel.useState((s) => s);
  useEffect(() => {
    QuestsModel.loadQuestsList(false);
  }, []);

  const options = useMemo(() => {
    if (!workflows) {
      return undefined;
    }
    let questOptions: SelectableOption[] = [];
    if (workflows) {
      for (var i = 0; i < workflows.length; i++) {
        if (workflows[i].quests.length == 0) continue;
        if (filterJourney && !filterJourney(workflows[i]!.journey!)) continue;

        const journeyQuests: SelectableOption[] = [];

        for (var q = 0; q < workflows[i].quests.length; q++) {
          const quest = workflows[i].quests[q];
          if (filterQuest && !filterQuest(quest)) continue;
          journeyQuests.push({ value: quest.slug, label: quest?.name });
        }

        if (journeyQuests.length > 0) {
          questOptions.push({ isHeading: true, label: workflows[i].journey?.name || "Unassigned" });
          questOptions.push(...journeyQuests);
        }
      }
    }
    questOptions = prependOptions ? prependOptions.concat(questOptions) : questOptions;
    return questOptions;
  }, [workflows, prependOptions, filterJourney, filterQuest]);

  return options;
}
